module.exports = __webpack_public_path__ + "img/database.dabdf9b8.svg";